export const getError = state => state.addSystem.get('error')
export const getIsSubmitting = state => state.addSystem.get('isSubmitting')
export const getSystemFailed = state => state.addSystem.get('systemFailed')
